import { IGroup } from "@grassrootly/api/entities";
import { UpdateGroupPayload } from "@grassrootly/api/gateways";
import withErrorCheck from "../CheckError";
import server from "../Server";
import { decode } from "base64-arraybuffer";

export const UpdateGroup = async (params: UpdateGroupPayload): Promise<IGroup> => {
  const group = withErrorCheck(await server.from("Groups").select().eq("id", params.id))[0];
  if (!group) {
    throw new Error("Group not found.");
  }

  let groupLogo = group.group_logo;
  if (params.paylod.has("image")) {
    const newImage: { uri: string; name: string; contentType: string; base64: string } = JSON.parse(
      params.paylod.get("image") as string
    );
    const { data } = await server.storage
      .from("profile_pics")
      .upload(`groups/${group.id}/${newImage.name}`, decode(newImage.base64), {
        contentType: newImage.contentType,
        upsert: true
      });
    if (data && data.path) {
      const { data: publicData } = server.storage
        .from("profile_pics")
        .getPublicUrl(`groups/${group.id}/${newImage.name}`);
      if (publicData && publicData) {
        groupLogo = publicData.publicUrl;
      }
    }
  }

  const name = params.paylod.get("name") as string;
  const joinCode = params.paylod.get("join_code") as string;

  return withErrorCheck(
    await server
      .from("Groups")
      .update({ name: name || group.name, join_code: joinCode || null, group_logo: groupLogo })
      .eq("id", group.id)
      .select()
  )[0];
};
